import {Routes, Route} from 'external/react' 
import {getGroupRoute} from 'utils/routing'

import SectionContainer from './SectionContainer'

import Courses from './Courses'
import Units from './Units'
import Lesson from './Lesson'
import Assessments from './Assessments'
import Homeworks from './Homeworks'
import Grades from './Grades'

const sections = [
  {names: ['', 'units'], element: (<Units />)},
  {names: ['lesson'], element: (<Lesson/>)},
  {names: ['homework'], element: (<Homeworks />)},
  {names: ['grade'], element: (<Grades />)},
  {names: ['assessment'], element: (<Assessments />)}
]

const routes = sections.reduce((routes, {names, element}) => routes.concat(names.map(name => ({path: getGroupRoute(`${name}/*`), element}))), []) 

export default function MyCourses() {
  return (
    <Routes>
      <Route path="/" element={<Courses />} />
      <Route element={<SectionContainer />}>
        {routes.map(({path, element}, key) => (<Route path={path} element={element} key={key} />))}
      </Route>
    </Routes>
  )
}
